import bee from "./Bee"
export default {
    name: "Security",
    update_password(query, success, fail){
        var payload  = {
            _f_password: {
                old_password: query.old_password,
                new_password: query.new_password
            }
        };
        bee.token = localStorage.getItem("token");
        bee.update(payload).then(res=> {
            if (success) {
                //update local storage values
                bee.token = res._f_login.token;
                localStorage.setItem("token", bee.token);
                localStorage.setItem("user", JSON.stringify(res._f_login.user));
                success(res);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    update_username(query, success, fail){
        var payload  = {
            _f_username: {
                current_email: query.current_email,
                new_email: query.new_email,
                current_password: query.current_password
            }
        };
        bee.token = localStorage.getItem("token");
        bee.update(payload).then(res=> {
            if (success) {
                success(res);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    update_details(query, success, fail){
        //first login before executing this function just to prove that the persong sediting these 
        //details is the owner
        bee.update({
            user: {
                ... query.data,
                name: query.data.first_name + " " + query.data.last_name,
                _w: [
                    ["id","e",query.id]
                ]
            }
        }).then(res=> {
            //login 
            if (success) {
                success(res);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    get_system_users(query, success, fail){
        bee.get({
            users: {}
        }).then(res=> {
            if (success) {
                success(res.users);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    get_system_user(query, success, fail){
        bee.get({
            user: {
                _w: [
                    ["id","e",query.id]
                ]
            }
        }).then(res=> {
            if (success) {
                success(res.user);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    disable_account(query, success, fail){
        bee.update({
            user: {
                status : "deactivated",
                _w: [
                    ["id","e",query.id]
                ]
            }
        }).then(res=> {
            if (success) {
                success(res);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    enable_account(query, success, fail){
        bee.update({
            user: {
                status : "active",
                code: "",
                _w: [
                    ["id","e",query.id]
                ]
            }
        }).then(res=> {
            if (success) {
                success(res);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    is_user_admin(query, success, fail){
        bee.get({
            user_roles: {
                role: {},
                _w: [
                    ["user_id","e",query.id]
                ]
            }
        }).then(res=> {
            var is_admin = false;
            for (var index = 0; index < res.user_roles.length; index++) {
                var user_role = res.user_roles[index];
                if (user_role.role.name == "backofficcee" || user_role.role.name == "super role") {
                    is_admin = true;
                    break;
                }
            }
            
            if (success) {
                success(is_admin);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    make_admin(query, success, fail){
        bee.post({
            user_role: {
                user_id: query.id,
                role_id: 2,
                status: "active"
            },
        }).then(res=> {
            if (success) {
                success(res.user_role);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    get_system_admin_users(query, success, fail){
        bee.get({
            user_roles: {
                user: {},
                _w: [
                    [
                        ["role_id","e",1],
                        "OR",
                        ["role_id","e",2]
                    ]
                ]
            }
        }).then(res=> {
            var admins = [];
            var added_ids = [];
            for (var index = 0; index < res.user_roles.length; index++) {
                var user_role = res.user_roles[index];
                if(added_ids.indexOf(parseInt(user_role.user.id))){
                    admins.push(user_role.user);
                    added_ids.push(parseInt(user_role.user.id));
                }
            }
            if (success) {
                success(admins);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    remove_admin(query, success, fail){
        bee.delete({
            user_role: {
                _w:[
                    [
                        ["user_id","e",query.id],
                        "AND",
                        ["role_id","e",2]
                    ]
                ]
            },
        }).then(res=> {
            if (success) {
                success(res.user_role);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
}